import LoanQuoteForm from './components/LoanQuoteForm';

function App({ formType }) {
    return (
        <div className="container">
            <LoanQuoteForm formType={formType}/>
        </div>
    );
}

export default App;
